"use strict";
/**
 * @module "ethpm/registries/web3"
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
const paged_1 = __importDefault(require("./paged"));
class PackagesCursor extends paged_1.default {
    constructor(pageSize, length, web3, registry, packageIds) {
        super(pageSize);
        this.pointer = new bn_js_1.default(0);
        this.length = length.clone();
        this.web3 = web3;
        this.registry = registry;
        this.packageIds = packageIds;
        this.setPages(packageIds);
    }
    getName() {
        const promise = new Promise((resolve) => {
            const packageId = this.getDatum(this.pointer);
            if (packageId === null) {
                resolve('');
            }
            else {
                this.registry.methods.getPackageName(packageId).call().then((result) => resolve(result));
            }
        });
        this.pointer = this.pointer.addn(1);
        return {
            done: false,
            value: promise,
        };
    }
    next() {
        if (this.pointer.lt(this.length)) {
            return this.getName();
        }
        return {
            done: true,
            value: undefined,
        };
        const promise = new Promise((resolve) => {
            resolve(''); // TODO: empty string or something else?
        });
        this.pointer = this.pointer.addn(1);
        return {
            done: true,
            value: promise,
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}
exports.default = PackagesCursor;
